import {RefObject} from "react";

import {Tabs} from "@pg-design/tabs";

import {insertIf} from "../../../utils/insert_if";

interface IProps {
    refElements: {
        refAboutUs?: RefObject<HTMLTableSectionElement | null>;
        refAwards: RefObject<HTMLTableSectionElement | null>;
        refPromotions?: RefObject<HTMLTableSectionElement | null>;
        refOffers: RefObject<HTMLTableSectionElement | null>;
        refContact?: RefObject<HTMLTableSectionElement | null>;
    };
    visibleElement: string | null;
    hasPromotions: boolean;
    hasActiveFlatsAndHouses: boolean;
    hasAwards: boolean;
}

const SCROLL_OFFSET = -16; // 16px margin

export const VendorDetailNavBar = (props: IProps) => {
    const {visibleElement, refElements, hasPromotions, hasAwards, hasActiveFlatsAndHouses} = props;

    return (
        <Tabs
            color="gray"
            variant="contained"
            fullWidth
            value={visibleElement ?? undefined}
            tabs={[
                {
                    title: "O nas",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refAboutUs,
                    value: "about_us",
                    gtmClick: "O nas - nawigacja"
                },
                ...insertIf(hasActiveFlatsAndHouses, {
                    title: "Oferta",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refOffers,
                    value: "offers",
                    gtmClick: "Oferty - nawigacja"
                }),
                ...insertIf(hasAwards, {
                    title: "Nagrody i wyróżnienia",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refAwards,
                    value: "awards",
                    gtmClick: "Nagrody i wyróżnienia - nawigacja"
                }),
                ...insertIf(hasPromotions, {
                    title: "Oferty specjalne",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refPromotions,
                    value: "promotions",
                    gtmClick: "Promocje - nawigacja"
                }),
                {
                    title: "Kontakt",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refContact,
                    value: "contact",
                    gtmClick: "Kontakt - nawigacja"
                }
            ]}
        />
    );
};
import {RefObject} from "react";

import {Tabs} from "@pg-design/tabs";

import {insertIf} from "../../../utils/insert_if";

interface IProps {
    refElements: {
        refAboutUs?: RefObject<HTMLTableSectionElement | null>;
        refAwards: RefObject<HTMLTableSectionElement | null>;
        refPromotions?: RefObject<HTMLTableSectionElement | null>;
        refOffers: RefObject<HTMLTableSectionElement | null>;
        refContact?: RefObject<HTMLTableSectionElement | null>;
    };
    visibleElement: string | null;
    hasPromotions: boolean;
    hasActiveFlatsAndHouses: boolean;
    hasAwards: boolean;
}

const SCROLL_OFFSET = -16; // 16px margin

export const VendorDetailNavBar = (props: IProps) => {
    const {visibleElement, refElements, hasPromotions, hasAwards, hasActiveFlatsAndHouses} = props;

    return (
        <Tabs
            color="gray"
            variant="contained"
            fullWidth
            value={visibleElement ?? undefined}
            tabs={[
                {
                    title: "O nas",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refAboutUs,
                    value: "about_us",
                    gtmClick: "O nas - nawigacja"
                },
                ...insertIf(hasActiveFlatsAndHouses, {
                    title: "Oferta",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refOffers,
                    value: "offers",
                    gtmClick: "Oferty - nawigacja"
                }),
                ...insertIf(hasAwards, {
                    title: "Nagrody i wyróżnienia",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refAwards,
                    value: "awards",
                    gtmClick: "Nagrody i wyróżnienia - nawigacja"
                }),
                ...insertIf(hasPromotions, {
                    title: "Oferty specjalne",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refPromotions,
                    value: "promotions",
                    gtmClick: "Promocje - nawigacja"
                }),
                {
                    title: "Kontakt",
                    scrollOffset: SCROLL_OFFSET,
                    scrollRef: refElements.refContact,
                    value: "contact",
                    gtmClick: "Kontakt - nawigacja"
                }
            ]}
        />
    );
};
